import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CommonGridToolBarWithFilterText } from "../../../Components/Common Components/CommonComponents";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { CheckAccessFunc, formatDateAndTimeMeth2 } from "../../../Components/CommonFunctions/CommonFunctions";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function StoreAudit(props) {
  const { loggedData } = props
  const history = useHistory();
  const location = useLocation();
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [auditData, setauditData] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  let EditAccess = true
  if (loggedData?.module_name === "store_module") {
    EditAccess = (CheckAccessFunc("Store", "Purchase", "Audit", null, "Tab")?.editAccess)
  } else {
    EditAccess = (CheckAccessFunc("Store Sub Location", "Store", "Audit", null, "Tab")?.editAccess)
  }


  useEffect(() => {
    getAuditList()
    if (location.states?.success_message) {
      successMessage(location.states?.success_message)
      history.push({ states: { ...location?.states, success_message: "" } })
    }
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }

  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }


  const getAuditList = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.STORE_AUDIT_STOCK_HOME)
        .then((response) => {
          if (response.data.status === 'success') {
            setisloader(false)
            setauditData(response.data.data || [])
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const GetPrint = () => {
    try {
      RestAPIService.getAllPrint(Serviceurls.STORE_AUDIT_STOCK_HOME + `?export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const tableView = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box>
            <CommonGridToolBarWithFilterText />
          </Box>
        )
      }

      auditData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'sno', headerName: 'S.No', flex: 0.10,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.sno || '-'}</Box>)
        },
        {
          field: 'audit_code', headerName: 'Audit Code', flex: 0.13, type: "string",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.audit_code || '-'}</Box>)
        },
        {
          field: 'audit_date', headerName: 'Audit Date & Time', flex: 0.15, headerAlign: "center", align: "center",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.audit_date ? formatDateAndTimeMeth2(params?.row?.audit_date) : '-'}</Box>)
        },
        {
          field: 'created_by', headerName: 'User Name', flex: 0.20, type: 'string',
          renderCell: (params) => (params.row.created_by ? params.row.created_by?.length > 12 ?
            <Tooltip placement="top" title={params.row.created_by}><Typography fontSize={'0.9vw'}>{params.row.created_by?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.created_by || '-'}</Typography> : '-')
        },
        {
          field: 'module', headerName: 'Module Section', flex: 0.20, type: 'string',
          renderCell: (params) => {
            let LocationName = (params.row?.sub_location_name || params.row?.store_name || "-")
            return (
              LocationName ? LocationName?.length > 20 ?
                <Tooltip placement="top" title={LocationName}><Typography fontSize={'0.9vw'}>{LocationName?.slice(0, 12) + '...'}</Typography></Tooltip> :
                <Typography fontSize={'0.9vw'}>{LocationName || '-'}</Typography> : '-'
            )
          }
        },
        {
          field: 'status', headerName: 'Status', flex: 0.12, headerAlign: "center", align: "center",
          renderCell: ({ row }) => {
            let audit_status = row?.status === "Approved" ? "Approved" : row?.status === "Rejected" ? "Rejected" : row?.status === "Inaudit" ? "Inaudit" : row?.status === "Completed" ? "Completed" : "-"
            let divColor = row?.status === "Approved" ? "#ECFFE9" : row?.status === "Rejected" ? "#FFE9E9" : row?.status === "Inaudit" ? "#FFEFD8" : row?.status === "Completed" ? "#c6eafe" : null;
            let txtColor = row?.status === "Approved" ? "#1E972A" : row?.status === "Rejected" ? "#B82121" : row?.status === "Inaudit" ? "#dc8400" : row?.status === "Completed" ? "#2a60ff" : null;
            return (
              <Stack sx={{ paddingX: "0.4vw", paddingY: "0.2vw", borderRadius: "0.2vw", backgroundColor: divColor, border: `1px solid ${txtColor}`, width: '10vw', textAlign: 'center', display: 'flex', justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
                <Typography sx={{ color: txtColor, fontSize: "0.9vw" }}>{audit_status ? audit_status : "-"}</Typography>
                {(row.rejection_comments && row?.status === "Rejected") ? <Tooltip arrow placement="top" title={`Reject Reason : ${row.rejection_comments}`}>
                  <ErrorOutlineIcon fontSize="small" color="error" sx={{ marginLeft: "0.5vw" }} />
                </Tooltip> : null}
              </Stack>
            );
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.10, headerAlign: "center", align: "center",
          renderCell: (params) => (
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
              {EditAccess ? <Tooltip title={"Edit Audit"} placement="top" arrow>
                <IconButton disabled={(params?.row?.status === "Completed" && loggedData?.module_name !== "store_module") || params?.row?.status === "Approved"} emed_tid={'st_view_' + params?.id} className='eMed_usrconf_btn' onClick={() => {
                  history.push({ pathname: `/StorePurchase/Audit/Add`, states: { edit_audit: true, audit_data: params?.row } })
                }}>
                  <img src={((params?.row?.status === "Completed" && loggedData?.module_name !== "store_module") || params?.row?.status === "Approved") ? ImagePaths.DisabledEdit.default : ImagePaths.LabEditButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                </IconButton>
              </Tooltip> : null}
              <Tooltip title={"View Audit"} placement="top" arrow>
                <IconButton className='eMed_usrconf_btn' onClick={() => {
                  history.push({ pathname: `/StorePurchase/Audit/Add`, states: { view_audit: true, audit_data: params?.row } })
                }}>
                  <img src={ImagePaths.LabViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                </IconButton>
              </Tooltip>
            </Box>
          )
        },
      ];
      return (
        <Box sx={{ height: '70vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={auditData}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
        {EditAccess ? <Button size="small" variant="contained" sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={() => { history.push({ pathname: `/StorePurchase/Audit/Add`, states: { create_audit: true } }) }}>{`Create Audit`}</Button> : null}
        <Tooltip title={'Print'} placement="top">
          <IconButton onClick={() => { GetPrint() }}          >
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title={'Print'} placement="top">
          <IconButton>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ExportIcon.default} alt='filter' />
          </IconButton>
        </Tooltip> */}
      </Box>
      <Box>
        {tableView()}
      </Box>
      {
        (errorMsg && errorMsgText) ?
          <ToastMsg
            severity={'error'}
            msg={errorMsgText}
            msgPop={msgClose}
          />
          : null}
      {
        (successMsg && successMsgText) ?
          <ToastMsg
            severity={'success'}
            msg={successMsgText}
            msgPop={msgClose}
          />
          : null
      }
    </Box>
  );
};

export default StoreAudit;
